import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
  MatLegacySnackBarRef as MatSnackBarRef,
} from '@angular/material/legacy-snack-bar';

interface ToastData {
  message: string;
  action: string;
  debugEventId?: string;
}

@Component({
  standalone: false,
  selector: 'sbnb-toast-notification-snackbar',
  templateUrl: './toast-notification-snackbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastNotificationSnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<ToastNotificationSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastData
  ) {}

  dismiss() {
    this.snackBarRef.dismissWithAction();
  }
}
